import React from 'react';
import useIsMobile from '../../../customHooks/useIsMobileQuery';
import { useSearchParams } from '../../../customHooks/useSearchParams';
import { getCSSVariable } from '../../../stylesheets/cssVariablesUtils';
import '../../../stylesheets/stylesLayout/stop-sales-page.scss';
import { ListViewType } from '../../../types/lists/listTypes';
import { useStopSalesList } from '../../contextsProperty/ContextStopSales';
import StopSalesCalendar from './calendarView/StopSalesCalendar';
import StopSalesFiltersBar from './StopSalesFiltersBar';
import StopSalesCards from './tableView/StopSalesCards';
import StopSalesTable from './tableView/StopSalesTable';
import StopSalesPanel from './stopSalesPanel/StopSalesPanel';

const StopSales = () => {
    const { visibleView } = useStopSalesList();
    const { getSearchParam, removeSearchParam } = useSearchParams({
        base64: true,
    });
    const openedPanelId = getSearchParam('id');

    const handleClosePanel = () => {
        removeSearchParam('id');
    };

    const mobileBreakpoint = parseInt(getCSSVariable('lg'));
    const isMobile = useIsMobile(mobileBreakpoint);

    return (
        <div className='stop-sales__page'>
            <StopSalesFiltersBar />
            {visibleView === ListViewType.TABLE ? (
                isMobile ? (
                    <StopSalesCards />
                ) : (
                    <StopSalesTable />
                )
            ) : (
                <StopSalesCalendar />
            )}
            <StopSalesPanel open={!!openedPanelId} onClose={handleClosePanel} />
        </div>
    );
};

export default StopSales;
